import { buildBillingAndShippingAddressesInputSchema } from '../address/create-pair-input.js';
/** Customer pair-create has no defaultFlag — R4 always marks shipping as default. */
export const createCustomerBillingAndShippingAddressesInputSchema = buildBillingAndShippingAddressesInputSchema({ requireFullAddress: true });
//# sourceMappingURL=create-pair-input.js.map